import { unitMapping } from '#src/lib/style.ts';

type Props = {
  size?: keyof typeof unitMapping;
};
export const ProIcon = ({ size = 2 }: Props) => {
  return (
    <svg
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 6.7999C8.225 6.7999 8.4 6.9999 8.4 7.1999C8.4 7.4249 8.225 7.5999 8 7.5999H7.2V6.7999H8ZM4 6.7999C4.2 6.7999 4.4 6.9999 4.4 7.1999C4.4 7.4249 4.2 7.5999 4 7.5999H3.175V6.7999H4ZM14.4 2.3999C15.275 2.3999 16 3.1249 16 3.9999V11.9999C16 12.8999 15.275 13.5999 14.4 13.5999H1.6C0.7 13.5999 0 12.8999 0 11.9999V3.9999C0 3.1249 0.7 2.3999 1.6 2.3999H14.4ZM4 8.7999C4.875 8.7999 5.6 8.0999 5.6 7.1999C5.6 6.3249 4.875 5.5999 4 5.5999H2.575C2.25 5.5999 1.975 5.8749 1.975 6.1999V9.7999C1.975 10.1499 2.25 10.3999 2.575 10.3999C2.9 10.3999 3.175 10.1499 3.175 9.7999V8.7999H4ZM9.5 9.4749L8.875 8.5499C9.325 8.2749 9.6 7.7749 9.6 7.1999C9.6 6.3249 8.875 5.5999 8 5.5999H6.6C6.25 5.5999 6 5.8749 6 6.1999V9.7999C6 10.1499 6.25 10.3999 6.6 10.3999C6.925 10.3999 7.2 10.1499 7.2 9.7999V8.7999H7.625L8.475 10.1499C8.6 10.3249 8.8 10.3999 9 10.3999C9.1 10.3999 9.225 10.3749 9.325 10.3249C9.6 10.1249 9.675 9.7499 9.5 9.4749ZM12.2 10.3999C13.4 10.3999 14.4 9.3249 14.4 7.9999C14.4 6.6999 13.4 5.5999 12.2 5.5999C10.975 5.5999 10 6.6999 10 7.9999C10 9.3249 10.975 10.3999 12.2 10.3999ZM12.2 6.7999C12.75 6.7999 13.2 7.3499 13.2 7.9999C13.2 8.6749 12.75 9.1999 12.2 9.1999C11.625 9.1999 11.2 8.6749 11.2 7.9999C11.2 7.3499 11.625 6.7999 12.2 6.7999Z"
        fill="currentColor"
      />
    </svg>
  );
};
